"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _constants = require("../../constants");
var _Modal = _interopRequireDefault(require("./Modal"));
var _AutoIntl = _interopRequireDefault(require("../elements/AutoIntl"));
var _AuButton = _interopRequireWildcard(require("../elements/AuButton"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "container": "info_dialog-module__container___jPCC3",
  "icon": "info_dialog-module__icon___Lww8Y",
  "header": "info_dialog-module__header___Fqp1i",
  "body": "info_dialog-module__body___KkCtF",
  "buttons": "info_dialog-module__buttons___OZRaB",
  "button": "info_dialog-module__button___y68BS",
  "close": "info_dialog-module__close___Mw69n",
  "xclose": "info_dialog-module__xclose___yv_l5",
  "xclose_secret": "info_dialog-module__xclose_secret___sFlb9 info_dialog-module__xclose___yv_l5"
};
class InfoDialog extends _react.default.Component {
  static propTypes = {
    className: T.string,
    titleId: T.string,
    titleString: T.string,
    titleClassName: T.string,
    bodyClassName: T.string,
    messageId: T.string,
    messageString: T.string,
    buttonsClassName: T.string,
    closeDisplayId: T.string,
    closeClassName: T.string,
    onClose: T.func,
    showClose: T.bool,
    buttonType: T.string
  };
  static defaultProps = {
    closeDisplayId: 'au.dialog.ok',
    onClose: _constants.NOOP,
    showClose: true,
    buttonType: _AuButton.BUTTON_TYPE_SECONDARY
  };
  handleOnClose = ev => {
    this.props.onClose(ev);
  };
  render() {
    const {
      titleId,
      titleString,
      messageId,
      messageString,
      closeDisplayId,
      secret
    } = this.props;
    const {
      className,
      titleClassName,
      bodyClassName,
      buttonsClassName,
      buttonType,
      closeClassName,
      showClose
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_Modal.default, null, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.container, styles.icon, className)
    }, showClose && /*#__PURE__*/_react.default.createElement("a", {
      className: secret ? styles.xclose_secret : styles.xclose,
      onClick: this.handleOnClose
    }), /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      className: (0, _classnames.default)(styles.header, titleClassName),
      displayId: titleId,
      displayString: titleString,
      tag: "div"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.body, bodyClassName)
    }, this.props.children || /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      displayId: messageId,
      displayString: messageString
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.buttons, buttonsClassName)
    }, /*#__PURE__*/_react.default.createElement(_AuButton.default, {
      type: buttonType,
      className: (0, _classnames.default)(styles.close, closeClassName),
      displayId: closeDisplayId,
      onClick: this.handleOnClose
    }))));
  }
}
exports.default = InfoDialog;